import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './content-display-cards-with-icons-or-title.component.scss';
var ContentDisplayCardsWithIconsOrTitle = /** @class */ (function (_super) {
    tslib_1.__extends(ContentDisplayCardsWithIconsOrTitle, _super);
    function ContentDisplayCardsWithIconsOrTitle(element) {
        return _super.call(this, element) || this;
    }
    ContentDisplayCardsWithIconsOrTitle.prototype.init = function () { };
    ContentDisplayCardsWithIconsOrTitle.prototype.bindEvents = function () { };
    return ContentDisplayCardsWithIconsOrTitle;
}(Base));
export { ContentDisplayCardsWithIconsOrTitle };



//////////////////
// WEBPACK FOOTER
// ./components/content-display-cards-with-icons-or-title/content-display-cards-with-icons-or-title.component.ts
// module id = 227
// module chunks = 0